export default "__VITE_ASSET__GuIz71VB__"